import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import type { PersonType } from './personIdentified';
import { personTypesSchema } from './personIdentified';

export const ATTENTION = 'VISION/ATTENTION';

export interface IPersonAttentionPayload {
  snapshotId?: string;
  personType?: PersonType;
  faceId: string;
}

export const personAttentionPayloadSchema = objectSchemaOf<IPersonAttentionPayload>(
  {
    snapshotId: Joi.string().optional(),
    personType: personTypesSchema.optional(),
    faceId: Joi.string().required(),
  }
);

export interface IPersonAttentionAction {
  type: typeof ATTENTION;
  payload: IPersonAttentionPayload;
}

export const personAttentionActionSchema = objectSchemaOf<IPersonAttentionAction>(
  {
    type: Joi.string().required().valid(ATTENTION),
    payload: personAttentionPayloadSchema.required(),
  }
);

export const personAttention = actionCreator({
  type: ATTENTION,
  schema: personAttentionActionSchema,
});
